<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Tipos Atividade"
      :headers="tipoAtividadeHeaders"
      :customHeaders="customHeaders"
      :items="tiposAtividade"
      item-key="IdTipoAtividade"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroTipoAtividade 
      v-model="modalTipoAtividade"
      :tipoAtividade="tipoAtividade"
      @tipoAtividadeAdicionado="tipoAtividadeAdicionado"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import TipoAtividade from '@/domain/tipoAtividade/TipoAtividade';
import ModalCadastroTipoAtividade from '@/components/tipoAtividade/ModalCadastroTipoAtividade';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'TiposAtividadeView',
  components: {
    GridSyclus,
    ModalCadastroTipoAtividade
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100007
      },
      tipoAtividadeHeaders: [
        { text: "ID", value: "IdTipoAtividade" },
        { text: "Descrição", value: "Descricao" },
        { text: "Status", value: "Status" },
      ],
      customHeaders: ["Status"],
      loading: false,
      modalTipoAtividade: false,
      tipoAtividade: new TipoAtividade()
    }
  },
  computed: {
    ...mapGetters(['user', 'tiposAtividade']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'resetaTipoAtividadeWorkflows',
      'fetchTiposAtividadeSql',
      'fetchLayoutsSqlUsuario',
      'deleteTipoAtividade',
      'fetchTipoAtividadeWorkflows'
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100007 });
      await this.fetchTiposAtividadeSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalTipoAtividade = true;
      this.tipoAtividade = Object.assign({}, new TipoAtividade());
    },
    async editItemSelected(payload) {
      if (payload && payload.IdTipoAtividade) {
        this.tipoAtividade = payload;
        this.modalTipoAtividade = true;
        await this.fetchTipoAtividadeWorkflows(payload.IdTipoAtividade);
      } else if (payload.length) {
        this.tipoAtividade = payload[payload.length - 1];
        this.modalTipoAtividade = true;
        await this.fetchTipoAtividadeWorkflows(this.tipoAtividade.IdTipoAtividade);
      } else {
        this.showNotification({ text: "Selecione um tipo atividade para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteTipoAtividade(item.IdTipoAtividade));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os tipos atividade: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um tipo atividade para excluir.', status: 'error' });
      }
    },
    tipoAtividadeAdicionado() {
      this.tipoAtividade = Object.assign({}, new TipoAtividade());
    }
  },
  created() {
    changePageTitle('Tipos Atividade');
  }
}
</script>

<style>

</style>